import { render, staticRenderFns } from "./drugdetail2.vue?vue&type=template&id=dde183d0&scoped=true&"
import script from "./drugdetail2.vue?vue&type=script&lang=js&"
export * from "./drugdetail2.vue?vue&type=script&lang=js&"
import style0 from "./drugdetail2.vue?vue&type=style&index=0&id=dde183d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde183d0",
  null
  
)

export default component.exports